module.exports = __webpack_public_path__ + "img/medal-gold.81421025.svg";